import { MonitoredOperationListItemResponse } from '@6grain/masofa-monolith-api-client/common/model/monitoredOperationListItemResponse';
import { assignmentRowTitle, namedKeyLabel } from '@app/pages/admin/orchestration-identity.util';
import {
  AssignmentResultFilter,
  formatAssignmentResultTooltip,
  readAssignmentResultCount,
} from '@app/pages/admin/assignment-result-count.util';
import {
  AssignmentStateFilter,
  TagSeverity,
  assignmentStateSeverity,
} from '@app/pages/admin/orchestration-process-page/orchestration-process-page.util';
import {
  parseAssignmentTableFilterQuery,
  serializeAssignmentTableFilterQuery,
} from '@app/pages/admin/assignment-table-filter-query.util';

export interface SubscriptionAssignmentTableFilters {
  result: AssignmentResultFilter;
  state: AssignmentStateFilter;
  createdRange: Date[] | null;
}

export const parseSubscriptionAssignmentFilterQuery = parseAssignmentTableFilterQuery;
export const serializeSubscriptionAssignmentFilterQuery = serializeAssignmentTableFilterQuery;

export interface SubscriptionAssignmentRow {
  id: string;
  name: string;
  processKey: string;
  processLabel: string;
  state: string;
  stateSeverity: TagSeverity;
  createdAt?: string;
  progressLabel: string;
  resultCount: number | null;
  resultTooltip: string | null;
  error: string | null;
}

export function toSubscriptionAssignmentRow(
  item: MonitoredOperationListItemResponse,
  processes?: Array<{ key: string; displayName?: string }> | null,
): SubscriptionAssignmentRow {
  const processKey = item.operationType?.trim() || '';
  return {
    id: item.id ?? '',
    name: assignmentRowTitle(item.name, processKey, processes),
    processKey,
    processLabel: namedKeyLabel(processes, processKey) || processKey || '—',
    state: item.state ?? '—',
    stateSeverity: assignmentStateSeverity(item.state),
    createdAt: item.createdAt,
    progressLabel: `${item.progressPercentage ?? 0}%`,
    resultCount: readAssignmentResultCount(item),
    resultTooltip: formatAssignmentResultTooltip(item),
    error: item.error ?? null,
  };
}
